<template>
  <v-card>
    <v-card-text>
      <h3>Amount of Substance</h3>
      <convert-box></convert-box>
    </v-card-text>
  </v-card>
</template>

<script>
import ConvertBox from '../components/ConvertBox'

export default {
  components: { ConvertBox },
  data() {
    return {
      unit: [
        {
          text: 'millimole(mmol)',
          val: 1
        },
        {
          text: 'mol(mol)',
          val: 0.001
        },
        {
          text: 'gram-mole(g-mol)',
          val: 0.001
        },
        {
          text: 'kilomole(kmol)',
          val: 0.000001
        },
        {
          text: 'pound mole(lb-mol)',
          val: 0.000002204622621849
        }
      ]
    }
  },
  created() {
    this.$store.dispatch('setUnit', this.unit)
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// amount-of-subtance.vue?4ae9de56